import { RoleContext } from "context/RoleContext";
import { useContext, useEffect, useState } from "react";

export const TabBar = (props) => {
  const { onChangeTab, tabs, defaultTab  } = props || {};
  const [currentIndex, setCurrentIndex] = useState(0);
  const params = new URLSearchParams(window.location.search);
  const option = params.get("option");
  const role = useContext(RoleContext);

  useEffect(() => {
    if (option === "switchRole") {
      if (role === "Host") {
        setCurrentIndex(1);
      } else if (role === "Member") {
        setCurrentIndex(2);
      }
    } else {
      setCurrentIndex(0);
    }
  }, []);

  const changeTab = (index) => {
    setCurrentIndex(index);
    onChangeTab?.(index);
  };

  return (
    <div className="flex flex-row items-start order-2">
      {tabs?.map((tab, index) => (
        <button className="mr-4" onClick={() => changeTab(index)} key={tab}>
          <div
            className={`
              ${
                currentIndex === index
                  ? "border-solid border-b-2 pb-3 border-primary"
                  : ""
              }`}
          >
            <span
              className={`font-semibold text-xs md:text-sm lg:text-sm ${
                currentIndex === index ? "text-primary" : "text-gray-500"
              }`}
            >
              {tab}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};
